import { ICalendarWorkTemplateBase } from "@miplatform/types";
import { getGUIDArray } from "@miplatform/utils";

export function buildUnassignedWorkOrdersFilters(
  templates: ICalendarWorkTemplateBase[],
  eventType: string
): Record<string, unknown> {
  if (templates.length === 0) {
    return {};
  }

  return {
    assignment: {
      [eventType]: {
        [`${eventType}TemplateId`]: {
          in: getGUIDArray(templates.map((template) => template.id)),
        },
      },
    },
  };
}
